import React from 'react';
import { FaMapMarkerAlt, FaPlus, FaTimes } from 'react-icons/fa';
import { emptyShippingRow, MAX_SHIPPING_TABS, SHIPPING_ADDRESS_FIELDS } from './utils';

const BuyerLedgerShippingDetails = ({
  shippingAddresses,
  activeShippingTab,
  onTabChange,
  onAddTab,
  onRemoveTab,
  onShippingFieldChange,
}) => {
  const rows = shippingAddresses || [];
  const row = rows[activeShippingTab] || emptyShippingRow();

  return (
    <div className="card border-0 shadow-sm mb-4 blc-card blc-card-teal">
      <div className="card-header bg-white border-0 pb-0 d-flex flex-wrap align-items-center justify-content-between gap-2">
        <h5 className="mb-0 blc-card-title blc-card-title-teal">
          <FaMapMarkerAlt className="me-2" />
          Shipping Details
        </h5>
        <small className="text-muted">Up to {MAX_SHIPPING_TABS} addresses</small>
      </div>
      <div className="card-body">
        <ul className="nav nav-tabs flex-wrap mb-3 blc-shipping-tabs" role="tablist">
          {rows.map((_, idx) => (
            <li className="nav-item" key={idx} role="presentation">
              <button
                type="button"
                className={`nav-link ${activeShippingTab === idx ? 'active' : ''}`}
                onClick={() => onTabChange(idx)}
                role="tab"
                aria-selected={activeShippingTab === idx}
              >
                Address {idx + 1}
              </button>
            </li>
          ))}
          {rows.length < MAX_SHIPPING_TABS && (
            <li className="nav-item d-flex align-items-center ms-1" role="presentation">
              <button
                type="button"
                className="btn btn-sm btn-outline-secondary"
                onClick={onAddTab}
                title="Add shipping address"
              >
                <FaPlus className="me-1" />
                Add
              </button>
            </li>
          )}
        </ul>

        <div className="tab-content">
          <div className="d-flex justify-content-end mb-2">
            {rows.length > 1 && (
              <button
                type="button"
                className="btn btn-sm btn-outline-danger"
                onClick={() => onRemoveTab(activeShippingTab)}
              >
                <FaTimes className="me-1" />
                Remove this address
              </button>
            )}
          </div>
          <div className="row">
            {SHIPPING_ADDRESS_FIELDS.map((field) => (
              <div className="col-lg-6 mb-3" key={field.key}>
                <label className="form-label fw-semibold text-dark">{field.label}</label>
                <input
                  value={row[field.key] || ''}
                  onChange={(e) => onShippingFieldChange(activeShippingTab, field.key, e.target.value)}
                  className="form-control form-control-lg blc-input"
                  placeholder={field.placeholder}
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default BuyerLedgerShippingDetails;
